<div class="ptr-container"
     (touchstart)="onTouchStart($event)"
     (touchmove)="onTouchMove($event)"
     (touchend)="onTouchEnd()">
  <div class="ptr-indicator" [style.height.px]="pullDistance" *ngIf="isPulling">
    <mat-spinner diameter="24" *ngIf="isRefreshing"></mat-spinner>
    <mat-icon *ngIf="!isRefreshing">arrow_downward</mat-icon>
  </div>
  <ng-content></ng-content>
</div>
